export default {
  methods: {
    /* *********
     路由
     ********* */
    /**
     * 生成路由跳转对象
     * 可用于 RouterLink的 to绑定
     * 可用于 router.push
     */
    withSchoolRouterTo (routeName, params = {}, query) {
      return {
        name: routeName,
        params: {
          ...params
        },
        query
      }
    },
    /**
     * 路由跳转，顺便加上学校名
     */
    routerPush (routeName, params = {}, query) {
      this.$router.push(this.withSchoolRouterTo(routeName, params, query))
    },
    goBack () {
      this.$router.go(-1)
    },
    /* *********
     状态
     ********* */
    /**
     * 将 loading状态置为 false
     * [ -> loading]
     */
    setToLoading () {
      this.loading = true
    },
    /**
     * 将 loading状态置为 false
     * [ -> loading]
     */
    loaded () {
      this.loading = false
    },
    /**
     * 将服务端的数据保存到 data中
     * [ -> data]
     */
    setToDataObjectAsDataProperty (data) {
      this.data = data
    },
    /* *********
     事件
     ********* */
    emitInput (value) {
      this.$emit('input', value)
    },
    emitClick (value) {
      this.$emit('click', value)
    },
    emitChange (value) {
      this.$emit('change', value)
    },
    /* *********
     其它
     ********* */
    bind (func, that) {
      return func && func.bind(that)
    },
    emptyFunc () {},
    _print (o) {
      console.debug(o)
      return o
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/mixin.js